import { ThemeColors } from 'app/providers/ThemeProvider';
import { CountryType } from 'entities/City';
import { NotifyLeaveDaysLimits } from 'entities/Contract';

import { PaymentMethod } from 'entities/Payment';

export interface AppSchema {
  loadingCount: number;
  globalSettings: Nullable<GlobalSettings>;
  featureFlags: Nullable<FeatureFlags>;
}

export type FeatureFlags = Record<string, boolean>;

export enum Currencies {
  EUR = 'EUR',
  USD = 'USD',
  CHF = 'CHF',
  PLN = 'PLN',
  RUR = 'RUR',
}

export enum BookingDocumentsNames {
  PRIVACY_POLICY = 'Privacy Policy',
  COMPANY_RULES = 'Company rules',
  TERMS_AND_CONDITIONS = 'Terms & conditions',
  UNIT_RULES = 'Unit rules',
}

export interface GlobalSettings {
  bankingRequisits: string;
  logoUrl: string;
  currency: Currencies;
  isBookingAvailiable: boolean;
  isDepositApplied: boolean;
  reservationPeriod: string;
  themeColors: ThemeColors;
  paymentMethods: string[];
  invoiceLeadDays: string;
  notifyLeaveDays: NotifyLeaveDaysLimits;
  bookingDocuments: Array<{ docName: string; link: string }>;
  signUpDocuments: Array<{ docName: string; link: string }>;
  reservationDocuments: Array<{ docName: string; link: string }>;
  bookAndPayDocuments: Array<{ docName: string; link: string }>;
  country: CountryType;
  showGeneralPromotions: boolean;
  companyName: string;
  partnerKnowledgeBaseUrl: string;
  availableLanguages: string[];
  isStandaloneDeposit: boolean;
  arrivalDateLimit: number;
  publicPaymentMethods: Array<{ name: PaymentMethod; isAutoPaymentAllowed: boolean; imageUrl?: string }>;
  showPriceWithVat: boolean;
  isCustomerIdentificationNumberRequired: boolean;
  rentalInvoicesDuedateDaysDisplayBackshift: number;
  clientName: string;
  contactPhone: string;
  contactEmail: string;
  mobilePackage: string;
}
